import React, { useState } from 'react';

export function CardVerificationInputMask({ placeholder, setCardVerification }) {
  const [value, setValue] = useState('');

  const handleChange = (e) => {
    const masked = e.target.value.replace(/\D/g, '').substr(0, 4);
    if (setCardVerification) setCardVerification(masked);
    setValue(masked);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={value}
      onChange={handleChange}
      placeholder={placeholder || '123'}
      maxLength={4}
      id="verificationValue"
      name="verificationValue"
      data-iugu="verification_value"
      autoComplete="cc-csc"
      style={{
        border: '1px solid #D9D9D9',
        borderRadius: '5px',
        padding: '5px',
        fontSize: '16px',
        background: 'transparent',
        width: '100%',
        height: '40px',
        margin: '10px 0px',
        outline: 'none',
        boxShadow: 'none',
      }}
    />
  );
}
